import { MenuOutlined, PlusOutlined } from '@ant-design/icons'
import { DndContext } from '@dnd-kit/core'
import { restrictToVerticalAxis } from '@dnd-kit/modifiers'
import {
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { Card, Empty, Skeleton, Table } from 'antd'
import React from 'react'
import { Button } from 'src/common'
import ConfirmDeleteModal from '../../staff-and-role-management/ConfirmDeleteModal'
import { ContentModal } from '../ContentModal'
import { ContentDetailModal } from './ContentDetailModal'
import { useMemberUse } from './useMemberUse'
import { t } from 'i18next'

type Props = { activeTab?: string }

export const MemberUse = ({ activeTab }: Props) => {
  const {
    sensors,
    setShowModal,
    openConfirmDeleteModal,
    onDragEnd,
    onCloseConfirmModal,
    showModal,
    columns,
    memberUseList,
    onClose,
    isGettingMemberUseList,
    isDeletingMemberUse,
    onDeleteMemberUse,
    selectedRoadMap,
  } = useMemberUse({ activeTab })

  return (
    <Card>
      <div className="flex items-center justify-between py-[1.25rem] w-full">
        <div
          style={{
            flex: 1,
          }}
        />
        <Button
          htmlType="submit"
          type="primary"
          size="middle"
          className="submit__btn loginselected-btn"
          icon={<PlusOutlined className="!text-[16px]" />}
          style={{
            alignSelf: 'flex-end',
          }}
          onClick={() => {
            setShowModal(true)
          }}
        >
          {'Add new'}
        </Button>
      </div>
      {isGettingMemberUseList ? (
        <Skeleton
          paragraph={{ rows: 4 }}
          style={{
            marginTop: 10,
          }}
        />
      ) : memberUseList?.length === 0 ? (
        <>
          <Empty description={t('evolveLanding:no_data')} />
        </>
      ) : (
        <DndContext
          sensors={sensors}
          modifiers={[restrictToVerticalAxis]}
          onDragEnd={onDragEnd}
          autoScroll
        >
          <SortableContext
            // rowKey array
            items={memberUseList?.map((i) => i.id) ?? []}
            strategy={verticalListSortingStrategy}
          >
            <Table
              components={{
                body: {
                  row: Row,
                },
              }}
              pagination={false}
              rowKey="key"
              columns={columns}
              dataSource={memberUseList?.map((item: any, index: any) => {
                return {
                  ...item,
                  key: item?.id,
                }
              })}
            />
          </SortableContext>
        </DndContext>
      )}

      <ContentDetailModal
        open={showModal}
        onClose={onClose}
        isLoading={false}
        item={selectedRoadMap}
        noDefault={memberUseList?.length || 1}
      />

      <ConfirmDeleteModal
        title="Delete this section "
        content="Are you sure to delete this section?"
        open={openConfirmDeleteModal}
        onClose={onCloseConfirmModal}
        isLoading={isDeletingMemberUse || false}
        onDelete={onDeleteMemberUse}
      />
    </Card>
  )
}

interface RowProps extends React.HTMLAttributes<HTMLTableRowElement> {
  'data-row-key': string
}
const Row = ({ children, ...props }: RowProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: props['data-row-key'],
  })
  const style: React.CSSProperties = {
    ...props.style,
    transform: CSS.Transform.toString(transform && { ...transform, scaleY: 1 }),
    transition,
    ...(isDragging ? { position: 'relative', zIndex: 9999 } : {}),
  }

  return (
    <tr {...props} ref={setNodeRef} style={style} {...attributes}>
      {React.Children.map(children, (child) => {
        if ((child as React.ReactElement).key === 'test') {
          return React.cloneElement(child as React.ReactElement, {
            children: (
              <MenuOutlined
                ref={setActivatorNodeRef}
                style={{ touchAction: 'none', cursor: 'move' }}
                {...listeners}
              />
            ),
          })
        }
        return child
      })}
    </tr>
  )
}
